// extracted by mini-css-extract-plugin
export default {"appSelectedIcon":"AppSelectedIcon_appSelectedIcon__8cNxi","isCenter":"AppSelectedIcon_isCenter__oAahC"};